import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppInfo, SessionService } from './session.service';
import { _common } from './_common';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-signup-succeed',
    templateUrl: './signup.succeed.component.html',
    standalone: true,
    imports: [NgIf]
})
export class SignupSucceedComponent implements OnInit {

  _common = _common;
  email = '';
  name = ';'
  appName: string;
  app: AppInfo;
  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.route.queryParams

      .subscribe(params => {
        this.email = params.email;
        this.name = params.name;

        this.appName = params.app;
        this.app = SessionService.APPS.find((c) => c.id == this.appName);

        SessionService.fixTitle(this.appName);

      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();

  }


}
